import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllRepliesService = (comment_id: string | number) => {
  return HTTP_CLIENT.get(
    Endpoint.reply.getAllReplies.replace(":comment_id", comment_id.toString()),
  );
};

const CreateReplyService = (comment_id: string | number, data: any) => {
  return HTTP_CLIENT.post(
    Endpoint.reply.createReply.replace(":comment_id", comment_id.toString()),
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export { GetAllRepliesService, CreateReplyService };
